import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/Footer.css';
import { FaMapMarkerAlt, FaPhoneAlt, FaEnvelope , FaInstagram , FaFacebook , FaLinkedin } from 'react-icons/fa';
import logo from '../../assets/logo.png';


const Footer = () => {
  return (
    <footer>
      <div className="footer-content">
        <div className="footer-left">
          <div className="company-info">
          <Link to="/" onClick={() => window.scrollTo(0, 0)}>  
          <img src={logo} alt="Saarthi Logo" className="company-logo" />
          </Link>  
            <p><FaMapMarkerAlt className="footer-icon" />  Fountainhead, Office No 1, 0 th Floor, Opp. Bravuria Society, Balewadi Pune, Maharashtra 411045</p>
            <p><FaPhoneAlt /> +91 8827743823 , +91 7558340139</p>
            <p><FaEnvelope /> saarthiphysiotherapy@gmail.com</p>
          </div>
          <div className="map-container">
            <iframe
              title="Saarthi Location"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3782.108035113031!2d73.781425!3d18.5691675!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bc2bf96cd0321bb%3A0xa999801c96e618fb!2sSaarthi%20Physiotherapy%20Center!5e0!3m2!1sen!2sin!4v1744147061302!5m2!1sen!2sin"
              width="100%"
              height="200"
              style={{ border: '0' }}
              allowFullScreen=""
              loading="lazy"
            ></iframe>
          </div>
        </div>
    
        <div className="footer-links">
          <h4>QUICK LINKS</h4>
          <ul>
            <li><a href="/">Home</a></li>
            <li><a href="/about">About Us</a></li>
            <li><a href="/services">Our Services</a></li>
            <li><a href="/contact">Contact Us</a></li>
          </ul>
        </div>

        <div className="footer-links">
          <h4>OUR SERVICES</h4>
          <ul>
            <li>Musculoskeletal Physiotherapy</li>
            <li>Neurological Rehabilitation</li>
            <li>Sports Injury Therapy</li>
            <li>Pediatric Physiotherapy</li>
          </ul>
        </div>

        <div className="footer-links">
          <h4>SOCIAL LINKS</h4>
          <ul>
            <li><a href="https://www.instagram.com/saarthi.physiotherapycenter/"><FaInstagram className="footer-icon"/></a></li>
            <li><a href="https://www.linkedin.com/in/dr-aishwarya-joshi-pt-b06ba930a/"><FaLinkedin className="footer-icon"/></a></li>
            <li><a href="https://www.instagram.com/saarthi.physiotherapycenter/"><FaFacebook className="footer-icon"/></a></li>
          </ul>
        </div>
      </div>

      <div className="footer-bottom">
        <p><Link to="/login">© </Link>2025 Saarthi Physiotherapy All Rights Reserved | Developed By <a href="https://github.com/error-kevin">Kevin</a></p>
      </div>
    </footer>
  );
};

export default Footer;

